import { Breadcrumbs, Chip, Link, Stack } from "@mui/material";
import HerbImage from "../../assets/doors/6_cffx.jpeg";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { SiteRoutes } from "../../PageRouter";

export const Door6 = () => {
  const ingredients = [
    "Mandarine",
    "Zimt",
    "Hagebuttenschale",
    "Muskatblüte",
    "Sternanis",
    "Rosenblüten",
    "Kardamom",
    "Pfeffer",
    "Nelken",
    "Wacholderbeeren",
    "Zitronengras",
  ];

  const doorNr = 6;

  const shortDecription =
    "Wusstest du, dass...?\nGlühwein gibt es schon länger als Weihnachtsmärkte. Schon Menschen in der Antike haben Wein mit Pfeffer, Lorbeer und Safran versetzt und mit Honig gesüßt.\n\nUnd immer dran denken:\nMan sollte nur so viel trinken wie mit aller Gewalt reingeht.";

  const herbName = "Glühweingewürz";

  const recepieExample = (
    <div>
      0,75L Rotwein in einen Topf gießen, 4 TL Honig und <b>beide Fläschchen</b>{" "}
      Glühweingewürz aus dem Kalender in einem Teebeutel oder Teesieb dazugeben.
      12 - 15 Minuten bei geringer Wärmezufuhr ziehen lassen.
    </div>
  );

  const breadcrumb = (
    <Breadcrumbs maxItems={4} separator={<NavigateNextIcon fontSize="small" />}>
      <Link
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        color="inherit"
        href="/"
      >
        Start
      </Link>
      {SiteRoutes.map((route) => {
        if (route.doorNumber && route.doorNumber <= doorNr) {
          return (
            <Link
              key={route.path}
              underline="hover"
              color="inherit"
              href={route.path}
            >
              Tag {route.doorNumber}
            </Link>
          );
        } else {
          return undefined;
        }
      })}
    </Breadcrumbs>
  );

  return (
    <>
      <img src={HerbImage} className="herb_img" alt="herb" />
      {breadcrumb}
      <h1 className="herb_name">{herbName}</h1>
      <i>{shortDecription}</i>
      <h3 className="content">Inhalt</h3>
      <div>
        <Stack
          spacing={1}
          direction="row"
          useFlexGap
          flexWrap="wrap"
          justifyContent="center"
        >
          {ingredients.map((ingredient, i) => {
            return (
              <Chip
                key={i}
                style={{ flexGrow: 1 }}
                label={ingredient}
                variant={i % 2 === 0 ? "filled" : "outlined"}
              />
            );
          })}
        </Stack>
      </div>
      <h3>Rezeptidee</h3>
      {recepieExample}
    </>
  );
};
